import React from 'react';
import { Table } from 'antd';
import { HubspotField } from '../interfaces/interfaces';
import { commaSeparatedString } from '../../utils/utils';


interface HubspotFieldsTableProps {
  dataSource: HubspotField[];
}
const HubspotFieldsChangeTable: React.FC<HubspotFieldsTableProps> = ({ dataSource }) => {
  // Define columns for the table
  const columns = [
    {
      title: 'Field Name',
      dataIndex: 'fieldKey',
      key: 'fieldKey',
    },
    {
      title: 'HubSpot Data',
      dataIndex: 'hubspotData',
      key: 'hubspotData',
      render: (text: string, record:any) => text ? record.fieldKey !== 'Deal Amount' ? text : `$ ${commaSeparatedString(text)}` : text,
    },
    {
      title: 'Pricing Version Data',
      dataIndex: 'pricingVersionData',
      key: 'pricingVersionData',
      render: (text: string, record:any) => text ? record.fieldKey !== 'Deal Amount' ? text : `$ ${commaSeparatedString(text)}` : text,
    },
  ];

  // Transform data into a format suitable for the Ant Design Table
  const dataSourceMapped = dataSource.map((item, index) => ({
    key: index.toString(), // Use index as the unique key (better to use a unique identifier if available)
    fieldKey: item.key,
    hubspotData: item['Hubspot Data'],
    pricingVersionData: item['Pricing Version Data'],
  }));

  return <Table className='hubSpotFieldsChangeTable' dataSource={dataSourceMapped} columns={columns} pagination={false} />;
};

export default HubspotFieldsChangeTable;
